import PropTypes from 'prop-types';

import { Checkbox, handlePageClick, Pagination, Radio, usePaginatedItems } from '@utilities';

import { getOptionLabel } from '../../../../utilities/helpers';

import styles from './_index.module.scss';

const AttributeOptions = ({ activePrompt, activePromptAnswers, max, onAnswerChange, options }) => {
  const answersPerPage = 8;

  const { currentItems, itemsPerPage, pageCount, setOffset } = usePaginatedItems({
    items: options,
    itemsPerPage: answersPerPage,
  });
  const onPageChange = (event) => {
    handlePageClick({ event, items: options, itemsPerPage: answersPerPage, setOffset });
  };

  const handleAnswerChange = (newAnswer) => {
    if (max === 1) {
      onAnswerChange([newAnswer]);
    } else {
      const isSelected = activePromptAnswers.some(({ id }) => id === newAnswer.id);

      const updatedAnswers = isSelected
        ? activePromptAnswers.filter(({ id }) => id !== newAnswer.id)
        : [...activePromptAnswers, newAnswer];

      onAnswerChange(updatedAnswers);
    }
  };

  return (
    <div className={styles['options']}>
      <div>
        <ul className={styles['options-list']}>
          {currentItems?.map((option, index) => {
            const optionAnswers = activePromptAnswers
              ? activePromptAnswers.filter((activeAnswer) => activeAnswer.id === option.id)
              : [];

            const isChecked = optionAnswers?.length === 1;
            const optionAnswer = isChecked ? optionAnswers[0] : undefined;
            const value = optionAnswer || option;

            return (
              <li key={`option-${index}`}>
                {max === 1 ? (
                  <Radio
                    isChecked={isChecked}
                    label={getOptionLabel({ option })}
                    name={activePrompt?.id}
                    onChange={() => handleAnswerChange(option)}
                    value={value}
                  />
                ) : (
                  <Checkbox
                    className={isChecked ? styles['is-selected'] : ''}
                    isChecked={isChecked}
                    isInverseColor
                    label={getOptionLabel({ option })}
                    name={activePrompt?.id}
                    onChange={() => handleAnswerChange(option)}
                    value={value}
                  />
                )}
              </li>
            );
          })}
        </ul>
        <Pagination
          onPageChange={onPageChange}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          show={options?.length > itemsPerPage}
          variant="dots"
        />
      </div>
    </div>
  );
};

AttributeOptions.propTypes = {
  activePrompt: PropTypes.object,
  activePromptAnswers: PropTypes.array,
  max: PropTypes.number,
  onAnswerChange: PropTypes.func,
  options: PropTypes.array,
};

export default AttributeOptions;
